import {
  type PropsWithChildren,
  type ReactNode,
  forwardRef,
  useEffect,
} from 'react'
import { kuiperClassNames } from '../utils/kuiperClassNames'
import './styles.scss'

export type AlertProps = {
  aboveTitleContent?: ReactNode
  className?: string
  hideBody?: boolean
  message: string
  title: string
}

const Alert = forwardRef<HTMLDivElement, PropsWithChildren<AlertProps>>(
  (
    {
      aboveTitleContent,
      className,
      children,
      hideBody = false,
      message,
      title,
    },
    ref
  ) => {
    useEffect(() => {
      if (hideBody && typeof window.hideSelector !== 'undefined')
        window.hideSelector('.kuiper-modal-body')
      return () => {
        if (hideBody && typeof window.showSelector !== 'undefined')
          window.showSelector('.kuiper-modal-body')
      }
    }, [hideBody])

    return (
      <div
        css={className}
        className={kuiperClassNames('alert')}
        ref={ref}
        role="dialog"
      >
        <div className={kuiperClassNames('alert-message')}>
          {aboveTitleContent}
          <h1>{title}</h1>
          <h4>{message}</h4>
        </div>
        <div className={kuiperClassNames('alert-action')}>{children}</div>
      </div>
    )
  }
)

Alert.displayName = 'Kuiper: Alert'

export default Alert
